import { styled } from '@clickcease/cc-client-components-lib'

export const InputContainer = styled('div', {
  marginTop: '$4',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
})

export const MessageContainer = styled('div', {
  marginBottom: '$8',
})

export const IdsSelectionContainer = styled('section', {
  width: '100%',
  height: '291px',
  display: 'flex',
  flexDirection: 'column',
  overflow: 'auto',
})

export const SortEntity = styled('button', {
  all: 'unset',
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
})

export const SortIcon = styled('div', {
  fontSize: '$sm',
  color: '$neutral',
  marginInlineStart: '$2',
})

export const IdsSelectionRow = styled('div', {
  width: 'calc(100% - 20px)',
  display: 'flex',
  alignItems: 'center',
  padding: '$6 $5',
  borderBottom: '1px solid $lightNeutral',

  '> :nth-child(1)': {
    flex: '0.1',
  },
  '> :nth-child(2)': {
    flex: '1',
  },
  '> :nth-child(3)': {
    flex: '0.5',
  },

  variants: {
    header: {
      true: {
        borderBottom: '1px solid $neutral',
        padding: '$4 $5',
      },
    },
    noBorder: {
      true: {
        borderBottom: 'none',
      },
    },
  },
})

export const IdsTitleRow = styled('div', {
  width: 'calc(100% - 20px)',
  display: 'flex',
  alignItems: 'center',
  padding: '$6 $5',
  borderBottom: '1px solid $lightNeutral',
  border: 'none !important',
})
